<template>
  <v-col class="py-0">
    <v-form ref="form">
      <v-row>
        <v-col
          class="py-0"
          md="4"
          sm="12"
          lg="2"
        >
          <v-text-field
            v-model="contactCloned.JobTitle"
            :label="$t('common.position')"
            :placeholder="$t(`form.contact.placeholders.position`)"
            :rules="[notEmptyRules]"
            @change="commitClone"
          />
        </v-col>

        <v-col
          class="py-0"
          md="4"
          sm="12"
          lg="2"
        >
          <v-text-field
            v-model="contactCloned.FirstName"
            :label="$t('common.firstName')"
            :placeholder="$t(`form.contact.placeholders.firstName`)"
            :rules="[notEmptyRules]"
            @change="commitClone"
          />
        </v-col>

        <v-col
          class="py-0"
          md="4"
          sm="12"
          lg="2"
        >
          <v-text-field
            v-model="contactCloned.LastName"
            :label="$t('common.lastName')"
            :placeholder="$t(`form.contact.placeholders.lastName`)"
            :rules="[notEmptyRules]"
            @change="commitClone"
          />
        </v-col>

        <v-col
          class="py-0"
          md="6"
          sm="12"
          lg="3"
        >
          <v-text-field
            v-model="contactCloned.PhoneOffice"
            v-mask="'(###) ###-####'"
            :label="$t('common.number')"
            :placeholder="$t(`form.phone.placeholders.number`)"
            :rules="[notEmptyRules]"
            @change="commitClone"
          />
        </v-col>

        <v-col
          class="py-0"
          md="6"
          sm="12"
          lg="3"
        >
          <form-email
            v-model="contactCloned.ContactEmail"
            :is-disabled="contactCloned.IsPortalUser"
            types-locale-key="form.email.types"
            @change="commitClone"
          />
        </v-col>
      </v-row>

      <slot />
    </v-form>
  </v-col>
  </v-form>
</template>

<script>
import { models } from 'feathers-vuex';
// import TypesMixin from '../../mixins/types';

const { Contact } = models.api;

export default {
  name: 'Contact',

  /*   mixins: [
    TypesMixin
  ], */

  props: ['contact'],

  data() {
    return {
      // initialData: {},
      notEmptyRules: value => (!!value || 'Cannot be empty'),
      contactCloned: {},
    };
  },

  created() {
    this.contactCloned = this.contact.clone();
  },

  // watch: {
  //   data: {
  //     deep: true,
  //     handler(newValue) {
  //       const ne = { ...newValue };
  //       const init = { ...this.initialData };
  //       let contactToEmit = { ...newValue, valid: this.hasMandatoryField(newValue) };
  //       const isEmpty = this.isFormEmpty(newValue);
  //       delete ne.__ob__;
  //       delete ne.__proto__;
  //       delete init.__ob__;
  //       delete init.__proto__;
  //       if (!_.isEqual(ne, init) && (_.isEqual(ne._id, init._id))) {
  //         if (!isEmpty) {
  //           contactToEmit = this.$emit('dataChanged', contactToEmit);
  //         }
  //       } else if (_.isEqual(ne._id, init._id)) {
  //         this.$emit('noChange', contactToEmit);
  //       } else if (!_.isEqual(ne._id, init._id)) {
  //         this.initialData = ne;
  //       }
  //     },
  //   },
  // },

  // mounted() {
  //   this.initialData = { ...this.data };
  // },

  methods: {

    commitClone() {
      this.contactCloned.commit();
    }

    // hasMandatoryField(contact) {
    //   // eslint-disable-next-line max-len
    //   const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   return (_.get(contact, 'JobTitle.length', 0) > 0
    //     && _.get(contact, 'FirstName.length', 0) > 0
    //     && _.get(contact, 'LastName.length', 0) > 0
    //     && _.get(contact, 'ContactEmail.length', 0) > 0
    //     && _.get(contact, 'PhoneOffice.length', 0) > 0
    //     && emailPattern.test(contact.ContactEmail));
    // },

    // isFormEmpty(contact) {
    //   return _.get(contact, 'JobTitle.length', 0) === 0
    //     && _.get(contact, 'FirstName.length', 0) === 0
    //     && _.get(contact, 'LastName.length', 0) === 0
    //     && _.get(contact, 'ContactEmail.length', 0) === 0
    //     && _.get(contact, 'PhoneOffice.length', 0) === 0;
    // }
  }
};
</script>
